export default __webpack_public_path__ + "static/media/NotoSansSC-Regular.ed09cca7.ttf";